import styles from './DateTime.module.scss'
import { LOCALE_DATE_STRING_OPTIONS } from '../../constants'

export interface Props {
  value: string
  second?: '2-digit'
  timeZone?: string
  variant?: 'longdate' | 'shortdate'
}

// Shows a UTC ISO date in localized time format with the local timezone
const constructLogDateTimeFormat = (value: string, second?: '2-digit') => {
  const dateStr = new Date(value).toLocaleDateString(undefined)

  const timeStr = new Date(value).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second
  })

  return `${dateStr} ${timeStr}`
}

const DateTime = ({
  value,
  second,
  timeZone,
  variant = 'longdate'
}: Props) => {
  const timeFormat = variant === 'shortdate'
    ? constructLogDateTimeFormat(value, second)
    : new Date(value).toLocaleDateString(undefined, {
      ...LOCALE_DATE_STRING_OPTIONS,
      second,
      timeZone
    })

  return (
    <time
      className={styles.DateTime}
      dateTime={value}
    >
      {timeFormat}
    </time>
  )
}

export default DateTime
